import { createBlock, createCommentVNode, createElementBlock, defineComponent, normalizeClass, openBlock, unref } from "vue";
import { ScalarIconCheck } from "@scalar/icons";
var ScalarListboxCheckbox_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "ScalarListboxCheckbox",
	props: {
		selected: { type: Boolean },
		multiselect: { type: Boolean }
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["flex size-4 items-center justify-center p-0.75", [__props.selected ? "bg-c-accent text-b-1" : "shadow-border text-transparent", __props.multiselect ? "rounded" : "rounded-full"]]) }, [__props.selected ? (openBlock(), createBlock(unref(ScalarIconCheck), {
				key: 0,
				class: "size-3",
				weight: "bold"
			})) : createCommentVNode("", true)], 2);
		};
	}
});
//#endregion
export { ScalarListboxCheckbox_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarListboxCheckbox.vue_vue_type_script_setup_true_lang.js.map